import { API_URL } from '../../../../constants';

const paths = {
  getMyBusinessCard: (): string => `${API_URL}/my-business-card`,
  getMyAppleWalletBusinessCard: (): string => `${API_URL}/apple-wallet-business-card`,
  addToGoogleWallet: (): string => `${API_URL}/google-wallet-business-card`,
};

export default paths;
